import React, { useContext } from 'react';
import { navigate } from 'gatsby';

import { ViewportContext } from '../contexts/viewport';
import { useLanguage } from '../hooks/useLanguage';
import { usePaths } from '../hooks/usePaths';
import { useDataLayer } from '../hooks/useDataLayer';

import Button from './Button';
import Dropdown from './Dropdown';

export default function DropdownLanguages() {
  const { pushLanguageSelectedEvent } = useDataLayer();
  const { langKey, langMap, getLanguageFromLangKey } = useLanguage();
  const { otherLanguagesCurrentPath, currentPathHash } = usePaths();
  const { isSmallScreen } = useContext(ViewportContext);

  const handleClickLanguage = (path) => {
    navigate(`${path.gatsbyPath}${currentPathHash}`);
    pushLanguageSelectedEvent(getLanguageFromLangKey(path.node_locale));
  };

  return (
    <>
      <Dropdown
        button={{
          version: 'secondary-text',
          additionalClassNames: '--x-small',
          label: langMap[langKey]
        }}
      >
        {otherLanguagesCurrentPath?.map((path) => (
          <Button
            onClick={() => handleClickLanguage(path)}
            key={path.id}
            button={{
              version: `${isSmallScreen ? 'secondary' : 'tertiary'}-text`,
              additionalClassNames: '--x-small',
              label: langMap[path.node_locale]
            }}
          />
        ))}
      </Dropdown>
    </>
  );
}
